import actionTypes from '../../actions/dictionaries/dictionaries.action-types';

export default (state = {}, action) => {
  switch (action.type) {
    case actionTypes.FETCH_USER_TEMPLATES_DICTIONARY_SUCCESS:
      return { ...action.templates };
    default:
      return state;
  }
};


// WEBPACK FOOTER //
// ./src/modules/app/reducers/dictionaries/user-templates-dictionary.js